import { render, staticRenderFns } from "./DateRangePickerDemo.vue?vue&type=template&id=4a50af48&scoped=true&"
import script from "./DateRangePickerDemo.vue?vue&type=script&lang=js&"
export * from "./DateRangePickerDemo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a50af48",
  null
  
)

export default component.exports